const Footer = () => {
  return (
    <div className="flex justify-between mt-1 ml-1 mr-1">
      <span>        
        <a
          href="mailto:gremlinscellar@schema-tools.xyz">
          Got feedback? 📧
        </a>
      </span>
      <span>
        Powered by{' '}
        <a
          href="https://avro.apache.org/"
          className="text-blue-500"
          target="_blank"
          rel="noreferrer noopener"
        >
          Apache Avro
        </a>
        , licensed under the{' '}
        <a
          href="https://www.apache.org/licenses/LICENSE-2.0"
          className="text-blue-500"
          target="_blank"
          rel="noreferrer noopener"
        >
          Apache License 2.0
        </a>
      </span>
    </div>
  );
};

export default Footer;
